export default __webpack_public_path__ + "static/media/upgrade-prompt.a58f281f.svg";